import React from 'react';
import ChatbotModal from './chatbot/ChatbotModal';

/**
 * Chatbot Component
 * Main entry point for the chatbot system
 * Renders the modal
 * 
 * The chatbot automatically adapts based on:
 * - Authentication state (logged in vs guest)
 * - User role (admin, professional, client)
 * - Selected mode (search vs assistant for clients)
 * 
 * Note: The floating button is no longer needed on homepage
 * as the chat is now integrated directly in the hero section.
 * For admin/client/pro pages, the button is rendered in Layout.tsx
 */
const Chatbot = () => {
  return (
    <>
      <ChatbotModal />
    </>
  );
};

export default Chatbot;
